import artistSrc1 from './assets/Artist-01.jpg';
import artistSrc2 from './assets/Artist-02.jpg';
import artistSrc3 from './assets/Artist-03.jpg';
import artistSrc4 from './assets/Artist-04.jpg';
import artistSrc5 from './assets/Artist-05.jpg';
import artistSrc6 from './assets/Artist-06.jpg';
import artistSrc7 from './assets/Artist-07.jpg';
import artistSrc8 from './assets/Artist-08.jpg';
import artistSrc9 from './assets/Artist-09.jpg';
import artistSrc10 from './assets/Artist-10.jpg';
import artistSrc11 from './assets/Artist-11.jpg';
import artistSrc12 from './assets/Artist-12.jpg';
import artistSrc13 from './assets/Artist-13.jpg';
import artistSrc14 from './assets/Artist-14.jpg';
import artistSrc15 from './assets/Artist-15.jpg';
import artistSrc16 from './assets/Artist-16.jpg';
import artistSrc17 from './assets/Artist-17.jpg';
import artistSrc18 from './assets/Artist-18.jpg';

export const artists = [
  {
    imageSrc: artistSrc1,
    brand: 'SCHWARZKOPF',
    name: 'Joev Marchese',
    role: 'PLATFORM ARTIST',
    socialHandle: '@joeymarchese',
    socialLink: 'https://www.instagram.com/joeymarchese',
  },
  {
    imageSrc: artistSrc2,
    brand: 'SCHWARZKOPF',
    name: 'Robin La Chance',
    role: 'PLATFORM ARTIST',
    socialHandle: '@robin_la_chance',
    socialLink: 'https://www.instagram.com/robin_la_chance',
  },
  {
    imageSrc: artistSrc3,
    brand: 'SCHWARZKOPF',
    name: 'Nicole Pede',
    role: 'PLATFORM ARTIST',
    socialHandle: '@nmpede',
    socialLink: 'https://www.instagram.com/nmpede',
  },
  {
    imageSrc: artistSrc4,
    brand: 'SCHWARZKOPF',
    name: 'Marek Whitechurch',
    role: 'PLATFORM ARTIST',
    socialHandle: '@marek_whitechurch_hairstylist',
    socialLink: 'https://www.instagram.com/marek_whitechurch_hairstylist',
  },
  {
    imageSrc: artistSrc5,
    brand: 'SCHWARZKOPF',
    name: 'Mario Cicciarella',
    role: 'PLATFORM ARTIST',
    socialHandle: '@marcheech',
    socialLink: 'https://www.instagram.com/marcheech',
  },
  {
    imageSrc: artistSrc6,
    brand: 'SCHWARZKOPF',
    name: 'Mark Chamberlain',
    role: 'PLATFORM ARTIST',
    socialHandle: '@markchamberlain_hair',
    socialLink: 'https://www.instagram.com/markchamberlain_hair',
  },
  {
    imageSrc: artistSrc7,
    brand: 'SCHWARZKOPF',
    name: 'Katia Jananji',
    role: 'PLATFORM ARTIST',
    socialHandle: '@katiajananji',
    socialLink: 'https://www.instagram.com/katiajananji',
  },
  {
    imageSrc: artistSrc8,
    brand: 'JOICO',
    name: 'Melissa Duguay',
    role: 'MASTER ARTIST',
    socialHandle: '@melzduguay',
    socialLink: 'https://www.instagram.com/melzduguay',
  },
  {
    imageSrc: artistSrc9,
    brand: 'JOICO',
    name: 'Armineh Damanpak',
    role: 'ARTISTIC AMABASSADOR',
    socialHandle: '@hairbyarmineh',
    socialLink: 'https://www.instagram.com/hairbyarmineh',
  },
  {
    imageSrc: artistSrc10,
    brand: 'JOICO',
    name: 'Lisa Schoor',
    role: 'ARTISTIC EDUCATOR',
    socialHandle: '@lisaschoorhair',
    socialLink: 'https://www.instagram.com/lisaschoorhair',
  },
  {
    imageSrc: artistSrc11,
    brand: 'JOICO',
    name: 'François Bouffard',
    role: 'ARTISTIC EDUCATOR',
    socialHandle: '@francoisbouffard',
    socialLink: 'https://www.instagram.com/francoisbouffard',
  },
  {
    imageSrc: artistSrc12,
    brand: 'JOICO',
    name: 'Daniela Ross',
    role: 'ARTIST',
    socialHandle: '@deelicioushair',
    socialLink: 'https://www.instagram.com/deelicioushair',
  },
  {
    imageSrc: artistSrc13,
    brand: 'JOICO',
    name: 'Marc-André Poulin',
    role: 'ARTISTIC EDUCATOR',
    socialHandle: '@mapstylehair',
    socialLink: 'https://www.instagram.com/mapstylehair',
  },
  {
    imageSrc: artistSrc14,
    brand: 'JOICO',
    name: 'Staelle Coulombe',
    role: 'ARTISTIC EDUCATOR',
    socialHandle: '@Staellecolorful',
    socialLink: 'https://www.instagram.com/Staellecolorful',
  },
  {
    imageSrc: artistSrc15,
    brand: 'JOICO',
    name: 'Jeannyfer Bernier',
    role: 'ARTISTIC EDUCATOR',
    socialHandle: '@stylist.jeanny',
    socialLink: 'https://www.instagram.com/stylist.jeanny',
  },
  {
    imageSrc: artistSrc16,
    brand: 'STMNT',
    name: 'Paul Doyle',
    role: 'ARTISTIC AMABASSADOR',
    socialHandle: '@doylescuts',
    socialLink: 'https://www.instagram.com/doylescuts',
  },
  {
    imageSrc: artistSrc17,
    brand: 'STMNT',
    name: 'Chris Venditti',
    role: 'ARTISTIC AMABASSADOR',
    socialHandle: '@chrisvenditti.hair',
    socialLink: 'https://www.instagram.com/chrisvenditti.hair',
  },
  {
    imageSrc: artistSrc18,
    brand: 'DEVACURL',
    name: 'Denise Hosni',
    role: 'ARTIST',
    socialHandle: '@denise.hosni',
    socialLink: 'https://www.instagram.com/denise.hosni',
  },
];
